import { axios } from '@lib/axios';

type ObjectType = { [key: string]: any };

export async function sendFile<Response = any>(
    url: string,
    file: File | Blob,
    data: ObjectType = {},
): Promise<Response> {
    const headers = { 'Content-Type': 'multipart/form-data' };
    const formData = new FormData();

    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            formData.append(key, data[key]);
        }
    }
    formData.append('file', file);

    const res = await axios.post(url, formData, { headers });
    return res.data;
}
